export const modalStateEnum = {
  // Auth states
  Login: 'Login',
  AdminLogin: 'AdminLogin',
  GoogleTowFA: 'GoogleTowFA',
  SetPassword: 'SetPassword',
  ChangePassword: 'ChangePassword',
  ChangePasswordSuccessfully: 'ChangePasswordSuccessfully',
  CodeFromEmail: 'CodeFromEmail',
  Registration: 'Registration',
  RegistrationSuccessfully: 'RegistrationSuccessfully',
  RestorePassword: 'RestorePassword',
  RestorePasswordSuccessfully: 'RestorePasswordSuccessfully',
  WelcomeBackInGoogle: 'WelcomeBackInGoogle',
  NumberConfirmation: 'NumberConfirmation',
  MaxNumberConfirmation: 'MaxNumberConfirmation',

  // New password reset states
  ForgotPassword: 'ForgotPassword',
  ResetPassword: 'ResetPassword',

  // General modals
  ModalOrderDetails: 'ModalOrderDetails',
  ModalThankYou: 'ModalOrderDetails', // deprecated alias
  MoreAboutDish: 'MoreAboutDish',
  MoreAboutDishRefactored: 'MoreAboutDishRefactored',
  PhoneConfirmationInstructions: 'PhoneConfirmationInstructions',
  OrderVerification: 'OrderVerification',
  YooKassaWidget: 'YooKassaWidget',
  TBusinessWidget: 'TBusinessWidget',
  AlfaBankWidget: 'AlfaBankWidget',
  Error: 'Error',
  LoyaltyPrivileges: 'LoyaltyPrivileges',
  ModalMapYandex: 'ModalMapYandex',
  DeliveryRules: 'DeliveryRules',
  PreorderTime: 'PreorderTime',
  Onboarding: 'Onboarding',

  // Admin modals
  AddProduct: 'AddProduct',
  AddProductGroup: 'AddProductGroup',
  AddCategory: 'AddCategory',
  AddAddon: 'AddAddon',
  AddExcludeIngredient: 'AddExcludeIngredient',

  // Settings modals
  EditInstitutionSettings: 'EditInstitutionSettings',
  EditFrontPadSettings: 'EditFrontPadSettings',
  EditPaymentSettings: 'EditPaymentSettings',
  EditEmailSettings: 'EditEmailSettings',
  EditTelegramSettings: 'EditTelegramSettings',
  EditVisualSettings: 'EditVisualSettings',
  EditYandexSettings: 'EditYandexSettings',
  EditNewsSliderSettings: 'EditNewsSliderSettings',
  EditLegalSettings: 'EditLegalSettings',
  EditBranchesSettings: 'EditBranchesSettings',

  // Push notifications
  SendPushNotification: 'SendPushNotification',
  PushNotificationPermission: 'PushNotificationPermission',

  // Profile modals
  DeleteProfile: 'DeleteProfile',
} as const

export type ModalStateEnum = typeof modalStateEnum[keyof typeof modalStateEnum]
